// Shared extras for the printable Habit Loop PDF (letter portrait,
// diagram at y=1.0..7.5in, footer at y=10.5in). Used by the member
// download (/app/habits), the landing lead magnet, and the exit-intent
// popup so all three print the same page.

// If/then plan under the visual — the printable version of the
// obstacle-plan paragraph in the Habit Stacking article. When the member
// has written their own plan (ifThen), it prints filled in; otherwise the
// fill-in-the-blank worksheet version prints (lead-magnet PDFs).
export function addIfThenBlock(pdf, ifThen) {
  const cx = 4.25;
  const filled = (ifThen || "").trim();
  pdf.setTextColor(44, 48, 46);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);
  pdf.text("My if/then plan — for the week the loop breaks", cx, 8.2, { align: "center" });
  if (filled) {
    pdf.setFont("helvetica", "italic");
    pdf.setFontSize(12);
    const lines = pdf.splitTextToSize(`\u201C${filled}\u201D`, 6.4).slice(0, 4);
    pdf.text(lines, cx, 8.7, { align: "center" });
    pdf.setFont("helvetica", "normal");
  } else {
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(11);
    pdf.text("If ________________________________________________ ,", cx, 8.7, { align: "center" });
    pdf.text("then I will ________________________________________________ .", cx, 9.15, { align: "center" });
    pdf.setFontSize(9);
    pdf.setTextColor(120, 118, 113);
    const note = pdf.splitTextToSize(
      "The if names the moment that usually breaks the loop — a late shift, a road trip, a week that gets loud. " +
      "The then names the smallest version of the habit that still counts.",
      6.2,
    );
    pdf.text(note, cx, 9.55, { align: "center" });
  }
}
